<template>
<div class="decision">
  <div class="inline thin">
    <h1>
      <template v-for="(part, index) in data.title">
        <span v-if="part.type === 'text'" v-html="part.text" :key="index"></span>
        <a v-else-if="part.type === 'link'" :href="part.link" :key="index" target="_blank">{{ part.text }}</a>
      </template>
    </h1>
    <div class="center">
      <div class="text inline">
        <RichText v-for="(chunk, index) in data.text" :key="index" :parts="chunk.parts" :type="chunk.type" :variables="data.variables" :hints="hints"/>
      </div>
    </div>
  </div>
  <div class="buttons">
      <button
        class="link"
        v-for="option in data.options"
        :key="option.target"
        v-on:click="$emit('go_to', {option: option, variables: data.variables})"
        :title="option.note"
      >{{ option.text }}</button>
    <button
      v-if="data.options.length === 0 && final_page && data.number != final_page.number"
      class="link"
      v-on:click="$emit('go_to_final_page')"
    >{{ final_page.title }}</button>
      <!-- v-on:click="$emit('go_to', {option: option, variables: data.variables})" -->
  </div>
</div>
</template>

<script>
import RichText from './RichText'
export default {
  name: 'Decision',
  props: ['data', 'final_page', 'hints'],
  components: {
    RichText
  }
}
</script>

<style scoped lang="scss">
div.decision {
  min-height: 25rem;
  text-align: center;
  background-color: white;
  padding: 2rem;

  @media (max-width: 600px) {
    padding: 2rem 0.5rem;
  }

  div.thin {
    max-width: 60rem;
  }

  div.center {
    text-align: center;
  }

  div.inline {
    display: inline-block;
  }

  div.text {
    max-width: 40rem;
    margin-bottom: 2rem;
    font-size: 115%;
  }

  // special types of text
  div.legal {
    border: solid 2px #eeeeee;
    border-radius: 5px;
    background-color: #eeeeee;
    padding: 1rem;
    font-size: 1.25rem;

    &:before {
      content: "§";
      font-size: 2rem;
      float: left;
      padding-right: 1rem;
    }
  }

  div.recommendation {
    margin-top: 1rem;
    text-align: left;

    &:before {
      content: "\f0a4";
      font-family: "Font Awesome 5 Free";
      font-size: 1.5em;
      float: left;
      font-weight: 400;
      font-style: normal;
      color: #aaaaaa;
      padding-right: 1rem;
    }
  }

  div.tip {
    font-style: italic;
    font-size: 0.9125rem;
    margin-top: 1.5rem;

    /*&:before {
      content: "\f0eb";
      font-family: "Font Awesome 5 Free";
      font-size: 2em;
      float: left;
      font-weight: 400;
      font-style: normal;
    }*/
  }

  div.buttons {

    display: flex;
    flex-flow: row wrap;
    justify-content: center;

    button {
      font-size: 125%;
      margin: 0.5rem;
      padding: 0.375rem 0.825rem;
      border: solid 3px #555555;
      flex: 1 0 0;
      display: inline-block;
      max-width: 15rem;
      border-radius: 5px;
      background-color: #555555;
      color: white;

      @media (max-width: 600px) {
        margin: 0.2rem;
      }

      &:hover {
        background-color: #eeeeee;
        color: #444444;
      }
    }
  }

  h1 {
    /deep/ a {
      color: #50af47; //#42b983;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Decision.vue